import { tv } from "tailwind-variants";

import type { VariantProps } from "~/types/tailwindVariants";
import { ThemeName } from "~/utils/themeVariants.ts";

export const statusBadgeVariants = tv({
    base: "inline-flex whitespace-nowrap font-normal ring-1 ring-inset",
    variants: {
        theme: {
            [ThemeName.Primary]:
                "bg-blue-50 text-blue-700 ring-blue-600/20",
            [ThemeName.Success]:
                "bg-green-50 text-green-700 ring-green-600/20",
            [ThemeName.Neutral]:
                "bg-gray-50 text-gray-600 ring-gray-500/10",
            [ThemeName.NeutralDark]:
                "bg-gray-200 text-gray-800 ring-gray-500/10",
            [ThemeName.NeutralDarker]:
                "bg-gray-500 text-white ring-gray-500/10",
            [ThemeName.Warning]:
                "bg-yellow-50 text-yellow-800 ring-yellow-600/20",
            [ThemeName.Danger]: "bg-red-50 text-red-700 ring-red-600/20",
            [ThemeName.SuccessHighlight]:
                "bg-white text-success-700 ring-success-600/40",
        },
        size: {
            default: "px-2.5 py-0.5 text-xs",
            md: "px-3 py-1 text-sm",
            lg: "px-4 py-2.5 text-base",
        },
        borderRadius: {
            full: "rounded-full",
            default: "rounded-md",
            grouped: "first:rounded-l-md last:rounded-r-md",
        },
    },
    defaultVariants: {
        borderRadius: "default",
        isGrouped: false,
        theme: ThemeName.Neutral,
    },
});

export type StatusBadgeVariantProps = VariantProps<typeof statusBadgeVariants>;
